import { GLOBALS } from 'constants/settings';

class Subnav {
  constructor(name, elems) {

    this.elems  = elems;
    this.name   = name;


    this.options = [].slice.call(document.getElementsByClassName(`${this.name}-subnav-option`));

    this.options.map((option, i) => {
      option.addEventListener('click', (e) => {
        this.showSection(e.target);
      });
    });

    if (!$(`.${this.name}-subnav-option.active`).length) $(`.${this.name}-subnav-option`).first().trigger('click');

    this.deepLink();
  }

  deepLink() {
    let hash = (window.location.hash) ? window.location.hash.replace('#', '') : null;
    if (hash) $(`.${this.name}-subnav-option[data-option="${hash}"`).trigger('click');
  }

  showSection(target) {
    let active  = target.dataset.option;
    
    $(`.${this.name}-subnav-option`).removeClass('active');
    $(target).addClass('active');

    if ($(`.${this.name}-section:visible`).length) {
      $(`.${this.name}-section:visible`).fadeOut(GLOBALS.transition, 'swing', () => {
        $(`.${this.name}-${active}`).fadeIn(GLOBALS.transition);
      }); 
    } else $(`.${this.name}-${active}`).fadeIn(GLOBALS.transition);
  }
}

export default Subnav;



// WEBPACK FOOTER //
// ./app/javascript/global/subnav.js